import {CHANGE_TOBA_LIST_STORE_SETTINGS, TOBAS_LIST_PAGE_SHIFT} from "./index";

//action that changed the toba list store settings
export function changeTobaListStoreSettings(key, value) {
    return {
        type: CHANGE_TOBA_LIST_STORE_SETTINGS,
        payload: {
            key,
            value
        }
    }
}